import React, { useState } from 'react';
import { FiTag, FiAlertCircle } from 'react-icons/fi';
import Modal from '../common/Modal';
import ButtonLoading from '../ButtonLoading';
import { userRequest } from '../../utils/requestMethods';

const AddCategoryModal = ({ isOpen, onClose, schoolId, onCreated }) => {
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setName('');
    setSlug('');
    setError('');
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Category name is required.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await userRequest.post(`/schools/${schoolId}/finance/expense-categories`, {
        name: name.trim(),
        ...(slug && { slug: slug.trim() }),
      });
      onCreated?.();
      reset();
      onClose();
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to add category. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Add Custom Category" icon={<FiTag className="text-indigo-600 text-lg" />}>
      {error && (
        <div className="flex items-start gap-3 bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm mb-4">
          <FiAlertCircle className="mt-0.5 shrink-0" />
          <span>{error}</span>
        </div>
      )}
      <form onSubmit={submitHandler} className="space-y-4">
        <div>
          <label className="block mb-1.5 text-sm font-medium text-gray-700">Category Name</label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="e.g. Lab Equipment"
            className="w-full rounded-xl bg-gray-50 border border-gray-200 px-4 py-2.5 text-sm focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none"
          />
        </div>
        <div>
          <label className="block mb-1.5 text-sm font-medium text-gray-700">Slug (optional)</label>
          <input
            type="text"
            value={slug}
            onChange={e => setSlug(e.target.value)}
            placeholder="Auto-generated if left blank"
            className="w-full rounded-xl bg-gray-50 border border-gray-200 px-4 py-2.5 text-sm focus:border-indigo-500 focus:ring-indigo-500 focus:outline-none"
          />
        </div>

        {loading ? (
          <ButtonLoading styles="w-full text-white bg-indigo-500 font-medium rounded-full text-sm px-5 py-2.5 text-center" />
        ) : (
          <button
            type="submit"
            className="w-full text-white bg-indigo-600 hover:bg-indigo-700 font-medium rounded-full text-sm px-5 py-2.5 text-center transition-colors"
          >
            Add Category
          </button>
        )}
      </form>
    </Modal>
  );
};

export default AddCategoryModal;
